import request from '../request'
let link = process.env.NODE_ENV == 'development' ? '/host' : process.env.API;

// 设置身份
export const setIdentity = (data,cv_account_token) => {
    return request({
        url: `/v3/cv_accounts/${cv_account_token}/identify_info`,
        method: 'POST',
        data
    })
}

// 获取城市
// export const toObtainCity = (params) => {
//     return request({
//         url: '/v1/cities/hot_cities_and_pingyin_group_cities',
//         method: 'get',
//         params,
//     })
// }

// 获取热门职能
export const getHotName = (params) => {
    return request({
        url: link + '/static/v1/professions/hot_name',
        method: 'get',
        params
    })
}
// 更新求职意向信息
export const updateInten = (data) => {
    return request({
        url: `/v4/jobs/intentions`,
        method: 'PUT',
        data
    })
}

// Onboarding求职状态
export const getOnboardingState = (params) => {
  return request({
      url: `/v3/job_status_template`,
      method: 'GET',
      params
  })
}


